module.exports = __webpack_public_path__ + "img/motorcycle.7912fee8.svg";